import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-fresh-produce',
  templateUrl: './fresh-produce.component.html',
  styleUrls: ['./fresh-produce.component.css']
})
export class FreshProduceComponent implements OnInit {

  @Input() products;
  @Input() productsHeight;

  constructor() { }

  ngOnInit() {
    this.products = [];
  }
}
